import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spurningar',
  templateUrl: './spurningar.component.html',
  styleUrls: ['./spurningar.component.css']
})
export class SpurningarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
